import React from 'react';
import PrimeProjects from '../Component/PrimeProjects';
import BlogPage  from '../Component/BlogPage';

const Catalogue = () => {

    return(
        <>
            <PrimeProjects/>
            <BlogPage />
        </>
    );

};
export default Catalogue;